import Echo from 'laravel-echo'
window.Pusher = require('pusher-js')

const isDev = process.env.VUE_APP_ENV === 'development'

export function initEcho() {
    if (window.Echo) {
        return window.Echo;
    }

    if (!isDev) {
        // keep a reference if you ever need it later
        window.__console__ = window.console

        const noop = () => {}
        ;['log', 'info', 'debug', 'warn'].forEach((m) => (console[m] = noop))

        // If you want to block errors also, uncomment:
        console.error = noop
    }

    window.Echo = new Echo({
        broadcaster: process.env.VUE_APP_BROADCAST_DRIVER,
        key: process.env.VUE_APP_PUSHER_KEY,
        cluster: process.env.VUE_APP_PUSHER_CLUSTER,
        wsHost: process.env.VUE_APP_PUSHER_HOST,
        wsPort: process.env.VUE_APP_PUSHER_PORT,
        wssPort: process.env.VUE_APP_PUSHER_PORT,
        forceTLS: false,
        encrypted: false,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
        authEndpoint: '/broadcasting/auth',
        auth: {
            headers: {
                'X-CSRF-TOKEN': 'test'
            }
        }
    });

    // Enable Pusher logging for debugging (disable in production)
    // ⚠ WHEN CODE IS READY TO MERGE UAT OR PRODUCTION, THEN PLEASE CHANGE THE 'VUE_APP_ENV' IN THE .ENV FILE TO CORRECT VALUE ⚠
    if (!isDev) {
        // Pusher internal logs (you already have this)
        window.Pusher.logToConsole = true;

        // Echo logger (some builds call connector.pusher.log)
        if (window.Echo?.connector?.pusher) {
            window.Echo.connector.pusher.log = (...args) => console.log('[Echo]', ...args);
        }
    } else {
        // Disable Pusher logs in non-dev
        window.Pusher.logToConsole = false;
        window.Pusher.log = function () {};

        // Disable Echo logs in non-dev
        if (window.Echo?.connector?.pusher) {
            window.Echo.connector.pusher.log = function () {};
        }
    }

    // Connection state logging
    window.Echo.connector.pusher.connection.bind('connecting', () => {
        console.log('🔄 Connecting to WebSocket server...');
    });

    window.Echo.connector.pusher.connection.bind('connected', () => {
        console.log('✅ Connected to WebSocket server');
    });

    window.Echo.connector.pusher.connection.bind('unavailable', () => {
        console.warn('⚠️ WebSocket unavailable, will retry...');
    });

    window.Echo.connector.pusher.connection.bind('failed', () => {
        console.error('❌ Connection failed - Cannot connect to WebSocket');
    });

    window.Echo.connector.pusher.connection.bind('disconnected', () => {
        console.warn('❌ Disconnected from WebSocket server');
    });

    window.Echo.connector.pusher.connection.bind('error', (err) => {
        console.error('⚠️ Connection error:', err);
    });

    window.Echo.connector.pusher.connection.bind('state_change', (states) => {
        console.log(`🔄 State changed: ${states.previous} → ${states.current}`);
    });

    return window.Echo;
}

export function disconnectEcho() {
    if (window.Echo) {
        window.Echo.disconnect();
        window.Echo = null;
    }
}